import JwtService from "./jwt-service";
import UserService from "./user-service";
import PermissionsService from "./permissions-service";

const saveData = (data) => {
  JwtService.saveToken(data.token)
  UserService.saveUser(data.user)
  PermissionsService.savePermissions(data.permissions)
}

const getData = () => {
  return {
    token: JwtService.getToken(),
    user: UserService.getUser(),
    permissions: PermissionsService.getPermissions()
  }
}

const destroyData = () => {
  JwtService.destroyToken()
  UserService.destroyUser()
  PermissionsService.destroyPermissions()
}

export default { saveData, getData, destroyData }
